import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const BulkImportPage = lazy(() => import('./pages/BulkImportPage'));
const DataTransformationPage = lazy(() => import('./pages/DataTransformationPage'));
const DeduplicationPage = lazy(() => import('./pages/DeduplicationPage'));
const QualityValidationPage = lazy(() => import('./pages/QualityValidationPage'));
const OneClickMigrationsPage = lazy(() => import('./pages/OneClickMigrationsPage'));
const HistoricalArchivePage = lazy(() => import('./pages/HistoricalArchivePage'));

export const MigrationRoutes: RouteObject = {
  path: 'migration',
  element: <ModuleGuard moduleId="data.migration" />,
  handle: { crumb: 'Data Migration & MDM' },
  children: [
    { index: true, element: <Navigate to="bulk-import" replace /> },
    { path: 'bulk-import', element: <BulkImportPage />, handle: { crumb: 'Bulk Import' } },
    { path: 'data-transformation', element: <DataTransformationPage />, handle: { crumb: 'Data Transformation' } },
    { path: 'deduplication', element: <DeduplicationPage />, handle: { crumb: 'Deduplication' } },
    { path: 'quality-validation', element: <QualityValidationPage />, handle: { crumb: 'Quality Validation' } },
    { path: 'one-click-migrations', element: <OneClickMigrationsPage />, handle: { crumb: 'One Click Migrations' } },
    { path: 'historical-archive', element: <HistoricalArchivePage />, handle: { crumb: 'Historical Archive' } },
  ],
};
